export const SET_BOARDS = 'SET_BOARDS'
